import { observable, computed } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { HoverZoom } from '~domain/entities/HoverZoom';

export class ProductHoverZoomItemViewController extends ViewController {
    @observable hoverZoom: HoverZoom;
    @observable public xMousePosition: number = 0;
    @observable public yMousePosition: number = 0;
    @observable public zoomPercent: number = 0;
    @observable public hoverZoomInitialSize: number = 0;
    @observable public hoverZoomSizeThreshold: number = 0;

    constructor(hoverZoom: HoverZoom) {
        super();
        this.hoverZoom = hoverZoom;
    }

    @computed
    get data() {
        return {
            xMousePosition: this.xMousePosition,
            yMousePosition: this.yMousePosition,
            zoomPercent: this.zoomPercent,
            hoverZoomInitialSize: this.hoverZoomInitialSize,
            hoverZoomSizeThreshold: this.hoverZoomSizeThreshold
        };
    }

    public positionZoomImage = (zoomContainer: HTMLElement, zoomImageTarget: HTMLImageElement) => {
        const originalSourceSize = zoomImageTarget.naturalWidth;
        let zoomFactor;
        if (originalSourceSize >= this.hoverZoomSizeThreshold) {
            zoomFactor = 1;
        } else {
            zoomFactor = 1 + this.zoomPercent / 100;
        }
        const enlargedImageSize = originalSourceSize * zoomFactor;
        const zoomContainerOffset = zoomContainer.getBoundingClientRect();
        const containerPositionX = this.xMousePosition - zoomContainerOffset.left;
        const containerPositionY = this.yMousePosition - zoomContainerOffset.top;
        const imgRatio =
            (enlargedImageSize - this.hoverZoomInitialSize) / this.hoverZoomInitialSize;
        const zoomTargetPositionX = containerPositionX * -imgRatio;
        const zoomTargetPositionY = containerPositionY * -imgRatio;

        return {
            xPosPx: `${zoomTargetPositionX}px`,
            yPosPx: `${zoomTargetPositionY}px`,
            sizePx: `${enlargedImageSize}px`
        };
    };

    public closeZoom = () => {
        this.hoverZoom.closeZoom();
    };
}
